import { createFileRoute } from "@tanstack/react-router";

import { CoachLibraryProgramDetailsPage } from "src/pages/CoachLibraryProgramDetailsPage";

export const Route = createFileRoute(
  "/_auth/_coach/library/programs/$programId/",
)({
  component: CoachLibraryProgramDetailsPage,
  ssr: true,
});
